module.exports = __webpack_public_path__ + "img/copy_clipboard.61d33d5b.svg";